import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';
import { useSeo } from '@/hooks/useSeo';

export function NotFound() {
  const { t } = useTranslation();
  useSeo({ title: `${t('notFound.title')} — SQLMaster.uz`, noindex: true });
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
      <div className="text-gradient text-7xl font-extrabold sm:text-8xl">404</div>
      <h1 className="mt-4 text-2xl font-bold">{t('notFound.title')}</h1>
      <p className="mx-auto mt-2 max-w-md text-content-secondary">{t('notFound.message')}</p>
      <Link to="/" className="btn btn-primary mt-8 gap-2 px-6 py-3">
        <Home className="h-5 w-5" />
        {t('notFound.back')}
      </Link>
    </div>
  );
}
